<script>
  import relatorioServico from '../relatorio.servico';
  import CabecalhoRelatorio from '~componentes/CabecalhoRelatorio.vue';
  import TelaCheia from '~componentes/TelaCheia.vue';
  import ProtocolosConteiner from './ProtocolosConteiner.vue';

  export default {
    components: { CabecalhoRelatorio, TelaCheia, ProtocolosConteiner },
    data() {
      return {
        protocolo: '',
        relatorio: [],
      }
    },
    methods: {
      gerar() {
        this.relatorio = {};

        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");
            
            $('#gerar').button('loading');

            return relatorioServico.protocolos(this.protocolo);
          })
          .then(resultado => {
            this.relatorio = resultado;
            
            $('#gerar').button('reset');
            
            if (this.relatorio.length === 0) {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              this.$nextTick(() => {
                $('html, body').animate({
                  scrollTop: $('#relatorio').offset().top
                }, 800);
              });
            }
          })
          .catch(erro => {
            $('#gerar').button('reset');

            this.$mensagemErro(erro, 'Erro ao gerar relatório.');
          });
      },
    },
    computed: {
      
    },
    mounted() {
      this.$root.tituloDaPagina = `Relatório de Protocolos`;
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.$events.on('botaoAcao', function() {
        window.print();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">
    <form class="hidden-print" @submit.prevent="gerar">

      <div class="ibox float-e-margins">
        <div class="ibox-content">
          
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group required" :class="{'has-error': errors.has('protocolo')}">
                <label class="control-label" for="protocolo">Nº do Protocolo</label>

                <input 
                  v-model="protocolo"
                  type="text"
                  id="protocolo"
                  class="form-control"
                  data-vv-name="protocolo"
                  data-vv-as="nº do protocolo"
                  v-validate="'required'">

                <p class="text-danger" v-show="errors.has('protocolo')">{{ errors.first('protocolo') }}</p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <button 
                id="gerar"
                type="button" 
                class="btn btn-primary" 
                @click="gerar"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-line-chart"></i> 
              Gerar relatório
            </button>

            <tela-cheia
              texto="Visualizar em tela cheia"
              icone="arrows-alt"
              v-if="relatorio.length > 0">
            </tela-cheia>
          </div>
        </div>
      </div>
    </form>

    <cabecalho-relatorio titulo="Relatório de Protocolos" borda=""></cabecalho-relatorio>

    <div class="row" v-if="relatorio.length > 0" id="relatorio">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <protocolos-conteiner :relatorio="relatorio"></protocolos-conteiner>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/Protocolos.vue